// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"229": "a0d73981e58e8dc5","943": "d5fc4565112a87b8",}[chunkId] + ".css"
}